const reportStatus = {
	name: 'Report Status',
	fields: {},
	processStep: 'Process step',
	process: {
		open: 'Open',
		processing: 'In Progress',
		denied: 'Denied',
		done: 'Completed',
	},
}

export default reportStatus
